<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-form ref="formCheckOut">
          <v-card class="my-4 rounded-top" outlined="" min-width="100%">
            <v-card-title class="py-2">{{ $t("page.sectionEditor.keytime", 1) }}</v-card-title>
            <v-card-text>
              <v-row>
                  <v-col cols="12" md="6" sm="6" class="mt-3">
                    <DateTimeText 
                        :label="$t('page.sectionEditor.keytime')"
                        :time="Check"
                        @updateField="updateFieldCheck"
                    />
                  </v-col>
              </v-row>
            </v-card-text>          
          </v-card>

          <v-card class="my-4 rounded-top" outlined="" min-width="100%">
            <v-card-title class="py-2">{{ $t("page.sectionEditor.late_penalties", 1) }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12">
                  <v-switch
                    name="isLatePenalty"
                    dense
                    v-model="Check.isLatePenalty"
                    :input-value="Check.isLatePenalty"
                    :label="$t('page.sectionEditor.late_penalties')"
                    @change="updateCheckField('isLatePenalty', Check.isLatePenalty)"
                    :true-value="1"
                    :false-value="0"
                    color="blue"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="auto" sm="6">
                  <v-text-field
                    outlined
                    :label="$t('page.sectionEditor.hour_out')"
                    dense
                    name="inLateDsqMinute"
                    placeholder="0"
                    v-model="PenaltiesOutLate.dsqMinute"
                    :hint="$t('page.sectionEditor.calculated_original_keytime')"
                    persistent-hint
                    @input="updatePenalties('dsqMinute', PenaltiesOutLate)"
                    :rules="[ (v) => $inputRules({ value: v }, 'filled') ||  /^\d+$/.test(v) || $t('common.fomat_invalid_only_number') ]"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card>
    </v-col>
</v-row>
</template>
<style scoped lang="scss"></style>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import DateTimeText from './time-check/DateTimeText.vue';

export default {
  mixins: [apiCalls],
  components: { DateTimeText },
  props: ["Check","Section"],
  methods: {
    setPenalties: function () {
      let app = this;
      app.setOutPenalties();
    },
    setOutPenalties: function () {
      let app = this;
      let check = app.Check;
      check.penalties.map(function (penalty) {
        if (penalty.penaltyType == "early") {
          //do nothing
          //app.PenaltiesOutEarly = penalty;
        } else {
          app.PenaltiesOutLate = penalty;
        }
      });
    },
    validateTime(time) {
      const timeReg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
      return timeReg.test(time);
    },
    updatePenalties(field, penalty) {
      if (!this.validateTime(this.Check.keyTime)) return false;
      if (penalty[field] == "") return false;

      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        penaltyId: penalty.id,
        field: field,
        value: penalty[field]
      };
      this.$store.dispatch('addSectionCheckPenaltiesUpdateAction',formData);
    }, 
    updateCheckField(field, value) {
      if (!this.validateTime(this.Check.keyTime)) return false;
      if (value == "" && value != 0) return false;

      let valueReal = value;
      if(field == 'keyTime') valueReal = this.findKeyTime(value);
      
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        field, 
        value: valueReal
      };
      this.$store.dispatch('addSectionChecksInOutUpdateAction',formData);
    },
    updateFieldCheck({ item }) {
      this.updateCheckField('keyTime', item);
    },
    findKeyTime(value) {
        if(typeof value == 'object') {
          if(Object.prototype.hasOwnProperty.call(value,'keyTime')) {
            value = value.keyTime;
            return value;
          } else {
            for (const property in value) {
              if(this.findKeyTime(value[property])) {
                value = this.findKeyTime(value[property]);
                return value;
              }
            }
          }
        }
        return false;
    },
  },
  data() {
    return {
      //clock
      time: null,
      menu: false,
      modal: false,

      PenaltiesOutLate: [],
    };
  },
  created: function () {
    this.setPenalties();
  },
  computed: {
    formatInvalidRules() {
      return [ (v) => {
        return (v || "").length == 0 || /^\d+$/.test(v) || this.$t('common.fomat_invalid_only_number');
      } ];
    }
  }
};
</script>
